import { useEffect, useRef, useState } from 'react';
import { useDeepCommentingNavigationMessaging } from '../../messaging/messageHandlers';
export default function useEmbeddedCommentsNavigation({
  commentableArea,
  moduleId
}) {
  const highlightTimeoutRef = useRef(undefined);
  const [isHighlightedBySidebar, setIsHighlightedBySidebar] = useState(false);
  useDeepCommentingNavigationMessaging({
    onRequestScrollToModule: msg => {
      if (msg.payload.moduleId !== moduleId || !commentableArea) {
        return;
      }
      commentableArea === null || commentableArea === void 0 || commentableArea.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center'
      });
    },
    onRequestHighlightModule: msg => {
      if (msg.payload.moduleId !== moduleId) {
        setIsHighlightedBySidebar(false);
        return;
      }
      if (highlightTimeoutRef.current) {
        clearTimeout(highlightTimeoutRef.current);
      }
      setIsHighlightedBySidebar(true);
      highlightTimeoutRef.current = setTimeout(() => {
        setIsHighlightedBySidebar(false);
      }, 2000);
    }
  });
  useEffect(() => {
    // Clear the timeout when this component unmounts to remove references to the component's state
    // from the timeout queue, allowing the component to be garbage collected
    return () => {
      clearTimeout(highlightTimeoutRef.current);
    };
  }, []);
  return {
    isHighlightedBySidebar
  };
}